<div class="card flex items-center gap-4">
  <div class="flex items-center gap-2">
    <label class="text-gray-700 dark:text-gray-300"
      ><strong>Usine:</strong></label
    >
    <p-select
      [options]="plantOptions || []"
      [(ngModel)]="selectedPlant"
      name="selectedPlant"
      (onChange)="onPlantChange($event.value)"
      placeholder="Sélectionner une usine"
      [style]="{ width: '200px' }"
      size="small"
    ></p-select>
  </div>
  <div class="flex items-center gap-2">
    <label class="text-gray-700 dark:text-gray-300"
      ><strong>Groupe de gestion:</strong></label
    >
    <p-multiSelect
      [options]="plannerGroupOptions || []"
      [(ngModel)]="selectedPlannerGroups"
      name="selectedPlannerGroups"
      (onChange)="onPlannerGroupsChange($event.value)"
      placeholder="Sélectionner"
      [style]="{ width: '250px' }"
      [maxSelectedLabels]="2"
      selectedItemsLabel="{0} sélectionnés"
      size="small"
    ></p-multiSelect>
  </div>
  <div class="flex items-center gap-2">
    <label class="text-gray-700 dark:text-gray-300"
      ><strong>Poste de travail:</strong></label
    >
    <p-multiSelect
      [options]="workCenterOptions || []"
      [(ngModel)]="selectedWorkCenters"
      name="selectedWorkCenters"
      (onChange)="onWorkCentersChange($event.value)"
      placeholder="Sélectionner"
      [style]="{ width: '250px' }"
      [maxSelectedLabels]="2"
      selectedItemsLabel="{0} sélectionnés"
      size="small"
    ></p-multiSelect>
  </div>
  <div class="ml-auto flex items-center gap-2">
    <ng-content></ng-content>
  </div>
</div>
